import { checkServerResponse } from '@core/utils';
import { createClient, createConfig } from '@generated/unauth/client';

import { ENV } from '@/constants/env';

//* 요청 헤더·쿠키·인증을 읽지 않는다 — 읽는 순간 해당 라우트가 동적으로 전환된다
export const PublicClient = createClient(
  createConfig({ baseUrl: ENV.NEXT_PUBLIC_API_DOMAIN }),
);

PublicClient.interceptors.response.use(async (response: Response) => {
  await checkServerResponse(response);

  return response;
});
